/**
 * UK Location Coordinates Lookup
 * Maps location slugs to [latitude, longitude] coordinates
 * Coordinates are approximate center points for each area
 * Sources: Public domain Ordnance Survey data, OpenStreetMap
 */

export const UK_COORDINATES: Record<string, [number, number]> = {
  // Scotland
  'aberdeenshire': [57.1506, -2.1484],
  'angus': [56.7300, -2.8889],
  'argyll-and-bute': [56.3594, -5.5195],
  'city-of-aberdeen': [57.1497, -2.0943],
  'city-of-dundee': [56.4740, -2.9689],
  'city-of-edinburgh': [55.9533, -3.1883],
  'city-of-glasgow': [55.8609, -4.2518],
  'clackmannanshire': [56.1067, -3.7500],
  'dumfries-and-galloway': [55.0700, -3.6050],
  'east-ayrshire': [55.4167, -4.2833],
  'east-dunbartonshire': [55.9833, -4.2167],
  'east-lothian': [55.9500, -2.7667],
  'east-renfrewshire': [55.7833, -4.3833],
  'fife': [56.2088, -3.0700],
  'falkirk': [55.9992, -3.7833],
  'glasgow-city': [55.8609, -4.2518],
  'highland': [57.4778, -4.2247],
  'inverclyde': [55.9500, -4.7667],
  'midlothian': [55.8667, -3.0667],
  'moray': [57.5167, -3.2000],
  'na-h-eileanan-siar': [57.3535, -7.4144],
  'north-ayrshire': [55.6333, -4.7167],
  'north-lanarkshire': [55.8833, -3.9333],
  'orkney-islands': [58.9833, -2.9000],
  'perth-and-kinross': [56.4000, -3.8000],
  'renfrewshire': [55.8333, -4.4333],
  'scottish-borders': [55.6000, -2.7833],
  'shetland-islands': [60.2000, -1.2833],
  'south-ayrshire': [55.4167, -4.6167],
  'south-lanarkshire': [55.5833, -3.7833],
  'stirling': [56.1167, -4.0000],
  'west-dunbartonshire': [55.9500, -4.5667],
  'west-lothian': [55.8333, -3.5500],

  // Wales
  'blaenau-gwent': [51.7833, -3.2167],
  'bridgend': [51.5083, -3.5794],
  'caerphilly': [51.5833, -3.2333],
  'cardiff': [51.4816, -3.1791],
  'carmarthenshire': [51.8577, -4.3053],
  'ceredigion': [52.2333, -4.1667],
  'conwy': [53.2667, -3.8333],
  'denbighshire': [53.1833, -3.4167],
  'flintshire': [53.2000, -3.1167],
  'gwynedd': [53.0000, -4.0000],
  'isle-of-anglesey': [53.2833, -4.3500],
  'merthyr-tydfil': [51.7456, -3.3772],
  'monmouthshire': [51.7833, -2.9167],
  'neath-port-talbot': [51.6333, -3.8167],
  'newport': [51.5881, -2.9978],
  'pembrokeshire': [51.8500, -4.8167],
  'powys': [52.3500, -3.4333],
  'rhondda-cynon-taf': [51.6833, -3.4500],
  'swansea': [51.6214, -3.9433],
  'torfaen': [51.7000, -3.0333],
  'vale-of-glamorgan': [51.4167, -3.3500],
  'wrexham': [53.0167, -3.0333],

  // Northern Ireland
  'antrim-and-newtownabbey': [54.7167, -5.9500],
  'ards-and-north-down': [54.5500, -5.6000],
  'armagh-city-banbridge-and-craigavon': [54.3500, -6.4000],
  'causeway-coast-and-glens': [55.0833, -6.5167],
  'city-of-londonderry': [54.9966, -7.3086],
  'derry-city-and-strabane': [54.9966, -7.3086],
  'fermanagh-and-omagh': [54.3500, -7.6167],
  'lisburn-and-castlereagh': [54.5167, -6.0333],
  'mid-ulster': [54.5667, -6.6833],
  'mid-and-east-antrim': [54.9833, -6.1167],
  'newry-mourne-and-down': [54.1833, -6.0000],
  'belfast': [54.5973, -5.9301],

  // England - North East
  'county-durham': [54.7750, -1.5833],
  'darlington': [54.5236, -1.5594],
  'gateshead': [54.9570, -1.6019],
  'hartlepool': [54.6822, -1.2150],
  'middlesbrough': [54.5742, -1.2350],
  'newcastle-upon-tyne': [54.9783, -1.6178],
  'north-tyneside': [54.9714, -1.4694],
  'northumberland': [55.2500, -2.0500],
  'south-tyneside': [54.9631, -1.4419],
  'stockton-on-tees': [54.5700, -1.3167],
  'sunderland': [54.9067, -1.3814],

  // England - North West
  'blackburn-with-darwen': [53.7500, -2.4833],
  'blackpool': [53.8175, -3.0356],
  'bolton': [53.5833, -2.4167],
  'burnley': [53.8000, -2.3167],
  'bury': [53.5833, -2.3167],
  'cheshire-east': [53.1833, -2.2500],
  'cheshire-west-and-chester': [53.1833, -2.7500],
  'cumberland': [54.6833, -3.0167],
  'halton': [53.3500, -2.7167],
  'knowsley': [53.4667, -2.8667],
  'lancaster': [54.0500, -2.8000],
  'liverpool': [53.4084, -2.9916],
  'manchester': [53.4808, -2.2426],
  'oldham': [53.5500, -2.1167],
  'rochdale': [53.6167, -2.1500],
  'salford': [53.4833, -2.2833],
  'sefton': [53.5667, -2.9333],
  'south-ribble': [53.7333, -2.7000],
  'st-helens': [53.4500, -2.7333],
  'stockport': [53.4167, -2.1500],
  'tameside': [53.5000, -2.0833],
  'trafford': [53.4333, -2.3000],
  'warrington': [53.3900, -2.5800],
  'westmorland-and-furness': [54.3333, -2.7500],
  'wigan': [53.5333, -2.6167],

  // England - Yorkshire and Humber
  'barnsley': [53.5667, -1.4833],
  'calderdale': [53.7167, -2.0000],
  'craven': [54.0000, -2.0833],
  'doncaster': [53.3833, -1.2167],
  'east-riding-of-yorkshire': [53.9167, -0.8333],
  'harrogate': [53.9920, -1.5414],
  'hull': [53.7678, -0.3375],
  'kingston-upon-hull-city-of': [53.7678, -0.3375],
  'kirklees': [53.5833, -1.8000],
  'leeds': [53.8011, -1.5486],
  'north-east-lincolnshire': [53.5167, -0.0500],
  'north-lincolnshire': [53.6000, -0.5833],
  'north-yorkshire': [53.9667, -1.2500],
  'richmondshire': [54.4000, -1.8333],
  'rotherham': [53.4333, -1.2500],
  'ryedale': [54.2000, -0.8333],
  'scarborough': [54.2833, -0.4000],
  'sedbergh': [54.3167, -2.5167],
  'sheffield': [53.3811, -1.4700],
  'wakefield': [53.6833, -1.5000],
  'selby': [53.7833, -1.0667],
  'york': [53.9600, -1.0873],

  // England - East Midlands
  'amber-valley': [53.0333, -1.4167],
  'ashfield': [53.1000, -1.2500],
  'bassetlaw': [53.3667, -1.0167],
  'blaby': [52.5833, -1.1667],
  'bolsover': [53.2333, -1.2667],
  'broxtowe': [52.9500, -1.2167],
  'charnwood': [52.7500, -1.2000],
  'chesterfield': [53.2333, -1.4167],
  'derbyshire-dales': [53.0833, -1.5833],
  'derby-city': [52.9218, -1.4766],
  'erewash': [52.9667, -1.3500],
  'gedling': [52.9833, -1.1000],
  'harborough': [52.4833, -1.0000],
  'high-peak': [53.3667, -1.9000],
  'hinckley-and-bosworth': [52.5500, -1.3500],
  'leicester-city': [52.6386, -1.1317],
  'leicestershire': [52.7167, -1.2000],
  'lincoln': [53.2333, -0.5333],
  'lincolnshire': [53.1667, -0.2500],
  'mansfield': [53.1500, -1.2000],
  'newark-and-sherwood': [53.0833, -0.8333],
  'north-east-derbyshire': [53.2000, -1.4000],
  'north-kesteven': [53.0833, -0.4167],
  'north-west-leicestershire': [52.7500, -1.3500],
  'nottingham-city': [52.9548, -1.1581],
  'oadby-and-wigston': [52.5667, -1.1000],
  'rushcliffe': [52.9500, -1.0167],
  'south-derbyshire': [52.8833, -1.5333],
  'south-kesteven': [52.9500, -0.4167],
  'south-ripley': [53.0500, -1.4000],
  'tamberlaine': [52.7833, -2.1167],
  'west-lindsey': [53.3000, -0.4167],

  // England - West Midlands
  'birmingham': [52.4814, -1.8998],
  'bromsgrove': [52.3333, -2.0667],
  'coventry': [52.4068, -1.5197],
  'dudley': [52.5000, -2.0833],
  'east-staffordshire': [52.8833, -1.8167],
  'herefordshire': [52.0833, -2.7500],
  'lichfield': [52.6833, -1.8167],
  'malvern-hills': [52.1167, -2.3500],
  'newcastle-under-lyme': [53.0167, -2.2333],
  'north-warwickshire': [52.5667, -1.5833],
  'nuneaton-and-bedworth': [52.5167, -1.4667],
  'redditch': [52.3067, -1.9444],
  'rugby': [52.3667, -1.2500],
  'sandwell': [52.5167, -2.0333],
  'shropshire': [52.6833, -2.7500],
  'solihull': [52.4167, -1.7667],
  'south-staffordshire': [52.6833, -2.1333],
  'stafford': [52.8167, -2.1167],
  'staffordshire': [53.0000, -2.0000],
  'staffordshire-moorlands': [53.1000, -1.9667],
  'telford-and-wrekin': [52.7333, -2.5000],
  'walsall': [52.5833, -1.9667],
  'warwick': [52.2833, -1.5833],
  'warwickshire': [52.2500, -1.5000],
  'wolverhampton': [52.5810, -2.1284],
  'worcestershire': [52.2500, -2.2000],

  // England - East of England
  'babergh': [52.0167, 0.9167],
  'basildon': [51.5500, 0.4833],
  'bedford': [52.1333, -0.4167],
  'braintree': [51.8833, 0.5667],
  'brentwood': [51.6167, 0.3000],
  'broadland': [52.6833, 1.4500],
  'cambridge': [52.2053, 0.1218],
  'central-bedfordshire': [52.0000, -0.3500],
  'chelmsford': [51.7356, 0.4681],
  'colchester': [51.8889, 0.9031],
  'east-cambridgeshire': [52.4167, 0.2500],
  'east-suffolk': [52.2000, 1.4000],
  'epping-forest': [51.6833, 0.1000],
  'fenland': [52.6667, 0.0333],
  'great-yarmouth': [52.6081, 1.7306],
  'harlow': [51.7667, 0.1000],
  'hertsmere': [51.6833, -0.2500],
  'huntingdonshire': [52.4000, -0.2500],
  'ipswich': [52.0567, 1.1481],
  'king-s-lynn-and-west-norfolk': [52.7500, 0.4000],
  'luton': [51.8784, -0.4164],
  'maldon': [51.7333, -0.6667],
  'mid-suffolk': [52.1833, 1.0000],
  'middlesex': [51.5000, -0.1667],
  'north-norfolk': [52.9167, 1.2833],
  'norwich': [52.6286, 1.2922],
  'peterborough': [52.5695, -0.2403],
  'rochford': [51.5833, 0.7167],
  'south-cambridgeshire': [52.2000, 0.0500],
  'south-norfolk': [52.5500, 1.2000],
  'southend-on-sea': [51.5372, 0.7144],
  'st-albans': [51.7550, -0.3422],
  'suffolk-coastal': [52.2500, 1.5500],
  'tendring': [51.8333, 1.1333],
  'three-rivers': [51.6500, -0.5000],
  'thurrock': [51.4934, 0.3525],
  'uttlesford': [51.9500, 0.2833],
  'welwyn-hatfield': [51.7667, -0.2167],
  'west-suffolk': [52.2333, 0.7167],

  // England - South East
  'adur': [50.8333, -0.3333],
  'arun': [50.8500, -0.5667],
  'ashford': [51.1500, 0.8833],
  'basingstoke-and-deane': [51.2667, -1.0833],
  'bracknell-forest': [51.4167, -0.7667],
  'brighton-and-hove': [50.8225, -0.1372],
  'buckinghamshire': [51.8000, -0.7500],
  'canterbury': [51.2794, 1.0789],
  'chichester': [50.8333, -0.7833],
  'dartford': [51.4500, 0.2167],
  'dover': [51.1500, 1.3000],
  'east-hampshire': [51.0833, -0.9667],
  'eastbourne': [50.7680, 0.2900],
  'eastleigh': [50.9667, -1.3500],
  'elmbridge': [51.3667, -0.4000],
  'epsom-and-ewell': [51.3167, -0.2500],
  'fareham': [50.8500, -1.1833],
  'folkestone-and-hythe': [51.0833, 1.0833],
  'gosport': [50.8000, -1.1333],
  'gravesham': [51.4000, 0.3667],
  'guildford': [51.2364, -0.5664],
  'hampshire': [51.0667, -1.2500],
  'harefield': [51.6000, -0.5000],
  'hart': [51.3167, -0.9167],
  'haslemere': [51.0833, -0.7000],
  'hastings': [50.8589, 0.5744],
  'havant': [50.8500, -0.9833],
  'horsham': [51.0667, -0.3333],
  'isle-of-wight': [50.6833, -1.3167],
  'kent': [51.2500, 0.7500],
  'lewes': [50.8167, 0.0167],
  'maidstone': [51.2667, 0.5167],
  'medway': [51.4000, 0.5000],
  'mid-sussex': [51.0000, -0.1667],
  'milton-keynes': [52.0417, -0.7756],
  'mole-valley': [51.3167, -0.3333],
  'new-forest': [50.8667, -1.5833],
  'oxford': [51.7500, -1.2500],
  'portsmouth': [50.8058, -1.0833],
  'reading': [51.4525, -0.9689],
  'redhill': [51.2333, -0.1667],
  'reigate-and-banstead': [51.2333, -0.2000],
  'rother': [50.9500, 0.6167],
  'runnymede': [51.4000, -0.5500],
  'sevonoaks': [51.2667, 0.1833],
  'slough': [51.5095, -0.5955],
  'south-oxfordshire': [51.7500, -1.0000],
  'southampton': [50.9045, -1.4045],
  'spelthorne': [51.4167, -0.4500],
  'surrey-heath': [51.3333, -0.6667],
  'swale': [51.3333, 0.8833],
  'tandridge': [51.2667, -0.0333],
  'test-valley': [51.0833, -1.5000],
  'thanet': [51.3500, 1.4000],
  'tonbridge-and-malling': [51.2500, 0.3500],
  'tunbridge-wells': [51.1333, 0.2833],
  'vale-of-white-horse': [51.6333, -1.4500],
  'valley': [53.2833, -4.3500],
  'wantage': [51.6000, -1.4333],
  'waverley': [51.1333, -0.6167],
  'west-berkshire': [51.4333, -1.1833],
  'west-oxfordshire': [51.8333, -1.5000],
  'winchester': [51.0633, -1.3078],
  'windsor-and-maidenhead': [51.4833, -0.6500],
  'woking': [51.3167, -0.5500],
  'wokingham': [51.4167, -0.8667],
  'worthing': [50.8167, -0.3667],
  'wycombe': [51.7500, -0.7500],

  // England - South West
  'bath-and-north-east-somerset': [51.3750, -2.4878],
  'bournemouth-christchurch-and-poole': [50.7192, -1.9917],
  'bristol': [51.4545, -2.5879],
  'cheltenham': [51.9000, -2.0667],
  'cornwall': [50.4167, -5.0000],
  'cotswold': [51.8333, -1.8333],
  'east-devon': [50.7500, -3.4167],
  'exeter': [50.7184, -3.5339],
  'forest-of-dean': [51.8000, -2.5500],
  'gloucester': [51.8644, -2.2444],
  'mid-devon': [50.9167, -3.5833],
  'north-devon': [51.1000, -4.0833],
  'plymouth': [50.3755, -4.1426],
  'south-hams': [50.3500, -3.7667],
  'south-gloucestershire': [51.5167, -2.4667],
  'south-somerset': [51.0000, -2.5000],
  'stroud': [51.7500, -2.2833],
  'swindon': [51.5558, -1.7817],
  'taunton-deane': [51.0167, -3.1000],
  'teignbridge': [50.6000, -3.6167],
  'torbay': [50.4619, -3.4931],
  'torridge': [50.9500, -4.1667],
  'west-devon': [50.7167, -4.1500],
  'wiltshire': [51.3333, -1.9667],
  'yate': [51.5333, -2.4167],
  'yeovil': [50.9500, -2.6333],

  // Greater London (boroughs)
  'barking-and-dagenham': [51.5397, 0.1319],
  'barnet': [51.6252, -0.1517],
  'bexley': [51.4549, 0.1319],
  'brent': [51.5588, -0.2817],
  'bromley': [51.3667, 0.0500],
  'camden': [51.5500, -0.1333],
  'city-of-london': [51.5155, -0.0922],
  'croydon': [51.3762, -0.0982],
  'ealing': [51.5130, -0.3089],
  'enfield': [51.6538, -0.0797],
  'greenwich': [51.4892, 0.0648],
  'hackney': [51.5450, -0.0553],
  'hammersmith-and-fulham': [51.4927, -0.2339],
  'haringey': [51.6000, -0.1119],
  'harrow': [51.5898, -0.3346],
  'havering': [51.5779, 0.2121],
  'hillingdon': [51.5441, -0.4760],
  'hounslow': [51.4746, -0.3680],
  'islington': [51.5465, -0.1058],
  'kensington-and-chelsea': [51.5020, -0.1947],
  'kingston-upon-thames': [51.4085, -0.3064],
  'lambeth': [51.4571, -0.1231],
  'lewisham': [51.4417, -0.0119],
  'merton': [51.4098, -0.1949],
  'newham': [51.5077, 0.0469],
  'redbridge': [51.5590, 0.0741],
  'richmond-upon-thames': [51.4478, -0.3269],
  'southwark': [51.5035, -0.0804],
  'sutton': [51.3500, -0.2000],
  'tower-hamlets': [51.5099, -0.0059],
  'waltham-forest': [51.5908, -0.0134],
  'wandsworth': [51.4567, -0.1910],
  'westminster': [51.4973, -0.1357],

  // Additional missing coordinates
  'boston': [52.9784, -0.0336],
  'bradford': [53.7960, -1.7594],
  'breckland': [52.5833, 0.6667],
  'broxbourne': [51.7333, -0.0333],
  'cannock-chase': [52.6833, -2.0333],
  'castle-point': [51.5500, 0.6000],
  'cherwell': [51.8500, -1.3000],
  'chorley': [53.6500, -2.6167],
  'city-of-bristol': [51.4545, -2.5879],
  'city-of-derby': [52.9218, -1.4766],
  'city-of-kingston-upon-hull': [53.7678, -0.3375],
  'city-of-nottingham': [52.9548, -1.1581],
  'city-of-peterborough': [52.5695, -0.2403],
  'city-of-plymouth': [50.3755, -4.1426],
  'city-of-westminster': [51.4973, -0.1357],
  'crawley': [51.1131, -0.1872],
  'dacorum': [51.7667, -0.4500],
  'dorset': [50.7500, -2.3333],
  'east-hertfordshire': [51.8000, -0.0500],
  'east-lindsey': [53.1667, 0.0833],
  'fylde': [53.8000, -2.9667],
  'hyndburn': [53.7500, -2.3833],
  'kings-lynn-and-west-norfolk': [52.7500, 0.4000],
  'leicester': [52.6386, -1.1317],
  'melton': [52.7667, -0.8500],
  'north-hertfordshire': [51.9333, -0.2833],
  'north-northamptonshire': [52.3500, -0.6000],
  'north-somerset': [51.4000, -2.8000],
  'pendle': [53.8333, -2.2167],
  'preston': [53.7575, -2.7041],
  'redcar-and-cleveland': [54.5667, -1.0667],
  'ribble-valley': [53.9167, -2.4167],
  'rossendale': [53.6833, -2.3167],
  'rushmoor': [51.2500, -0.8333],
  'rutland': [52.6500, -0.6500],
  'sevenoaks': [51.2667, 0.1833],
  'somerset': [51.0833, -2.8333],
  'south-holland': [52.8167, -0.1333],
  'stevenage': [51.9022, -0.2011],
  'stoke-on-trent': [53.0042, -2.1794],
  'stratford-on-avon': [52.2000, -1.7000],
  'tamworth': [52.6333, -1.7000],
  'tewkesbury': [51.9833, -2.1667],
  'watford': [51.6567, -0.3903],
  'wealden': [50.9833, 0.1833],
  'west-lancashire': [53.5833, -2.8000],
  'west-northamptonshire': [52.2833, -1.0833],
  'wirral': [53.3667, -3.0500],
  'worcester': [52.1920, -2.2200],
  'wychavon': [52.1333, -2.0833],
  'wyre': [53.8500, -2.9833],
  'wyre-forest': [52.4000, -2.3500],
};
